module.exports = __webpack_public_path__ + "img/logo-loegismose-stroke-medium-copy.326c1e76.png";